import { get } from "../../utils/objectHelpers";
$ {
const contactSellerText = get(input, 'contactAction.text', '');
const contactSellerURL = get(input, 'contactAction.action.URL', '');
}

<div class="contact-seller about-layout--gutters">
    <ebay-button href=contactSellerURL priority="primary">
        ${contactSellerText}
    </ebay-button>
</div>
